'use client'

// 沙箱模式警示橫幅。ECPAY_MODE 非 'production' 時顯示，提醒後台操作者
// 目前訂單皆為測試資料、付款流程未接真實金流。
// 透過 NEXT_PUBLIC_ECPAY_MODE 讓 client bundle 可讀；未設或非 production 皆視為沙箱。
export default function SandboxBanner() {
  const mode = (process.env.NEXT_PUBLIC_ECPAY_MODE ?? '').trim()
  if (mode === 'production') return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: 'linear-gradient(90deg, #FEF3C7 0%, #FDE68A 100%)',
        borderBottom: '1px solid #F59E0B',
        color: '#78350F',
        fontSize: '13px',
        lineHeight: 1.5,
        padding: '10px max(20px, env(safe-area-inset-left))',
        textAlign: 'center',
      }}
    >
      <strong>⚠️ 沙箱測試模式</strong>
      <span style={{ margin: '0 8px' }}>·</span>
      綠界審核通過前，所有訂單與付款事件皆為測試資料，未實際扣款
      <span style={{ margin: '0 8px', opacity: 0.5 }}>|</span>
      <span style={{ fontSize: '12px', opacity: 0.8 }}>
        切換 production 流程見 <code style={{ background: 'rgba(0,0,0,0.08)', padding: '1px 5px', borderRadius: 3 }}>DELIVERY_NOTES.md</code>
      </span>
    </div>
  )
}
